import RouterErrorBoundary from "@/errors/RouterErrorBoundary/RouterErrorBoundary";
import AuthLayout from "@/layouts/Auth";
import React, { lazy, Suspense } from "react";
import PublicRoute from "@/guards/PublicRoute";

const Login = lazy(() => import("@/features/auth/pages/Login"));
const Register = lazy(() => import("@/features/auth/pages/Register"));
const ForgetPassword = lazy(() =>
  import("@/features/auth/pages/ForgetPassword")
);
const ResetPassword = lazy(() => import("@/features/auth/pages/ResetPassword"));
const UserRegistration = lazy(() => import("@/features/auth/pages/UserRegistration"));
const VerifyEmail = lazy(() => import("@/features/auth/pages/VerifyEmail"));
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const authLayout = (
  <PublicRoute>
    <Suspense fallback={<LoadingFeedback />}>
      <AuthLayout />
    </Suspense>
  </PublicRoute>
);

export const authRoutes = [
  {
    path: "/auth",
    errorElement: <RouterErrorBoundary />,
    element: authLayout,
    children: [
      {
        path: "login",
        element: <Login />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "register",
        element: <Register />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "forget-password",
        element: <ForgetPassword />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "reset-password/:token",
        element: <ResetPassword />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "user-registration/:token",
        element: <UserRegistration />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "verify-email/:token",
        element: <VerifyEmail />,
        errorElement: <RouterErrorBoundary />,
      },
    ],
  },
  ...[
    ["/reset-password/:token", <ResetPassword />],
    ["/user-registration/:token", <UserRegistration />],
    ["/verify-email/:token", <VerifyEmail />],
  ].map(([path, page]) => ({
    path,
    errorElement: <RouterErrorBoundary />,
    element: authLayout,
    children: [{ index: true, element: page, errorElement: <RouterErrorBoundary /> }],
  })),
];
